import userApi from "./index"

export const getQuestions = async (filters) => {
  console.log({ filters }, "this is data")

  try {
    const {
      subtopicIds,
      topicIds,
      paperType,
      year,
      search,
      page = 1,
      limit = 10,
      mark,
    } = filters
    const queryParams = new URLSearchParams()

    if (subtopicIds) queryParams.append("subtopicIds", subtopicIds)
    if (topicIds) queryParams.append("topicIds", topicIds)
    if (paperType) queryParams.append("paper", paperType)
    if (year) queryParams.append("year", year)
    if (search) queryParams.append("searchText", search)
    if (mark) queryParams.append("marks", mark)
    queryParams.append("page", page)
    queryParams.append("limit", limit)

    const response = await userApi.get(`/questions?${queryParams.toString()}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getQuestionById = async (id) => {
  try {
    const response = await userApi.get(`/question/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}
